import { HttpClient } from '@angular/common/http';
import { inject, RESPONSE_INIT } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BusinessDetails } from '@App/common/models';
import { environment } from '@Environments';
import { catchError, map, of } from 'rxjs';
import { normalizeCardAlias } from './pitch-card-route.utils';

interface CardAliasResponse {
  data: BusinessDetails | null;
}

export const pitchCardResolver: ResolveFn<BusinessDetails | null> = (route) => {
  const http = inject(HttpClient);
  const responseInit = inject(RESPONSE_INIT, { optional: true });
  const alias = normalizeCardAlias(route.paramMap.get('alias'));
  const url = `${environment.basePath}search/alias/${encodeURIComponent(alias)}`;

  const markNotFound = () => {
    if (responseInit) {
      responseInit.status = 404;
    }
  };

  return http.get<CardAliasResponse>(url).pipe(
    map(({ data }) => {
      if (!data) {
        markNotFound();
      }
      return data;
    }),
    catchError(() => {
      markNotFound();
      return of(null);
    })
  );
};
